module.exports = __webpack_public_path__ + "static/media/logo.39759e74.svg";